import Grid from '@mui/material/Grid';
import Rating from '@mui/material/Rating';

export default function StarRating({
  averageRating,
  starRating
}: {
  averageRating: number;
  starRating: number;
}) {
  const rating = averageRating.toFixed(1);
  return (
    <Grid
      container
      alignItems="center"
      columnGap={1}
      fontSize={{ xs: '16px', sm: '16px', md: 'inherit' }}>
      {parseFloat(rating) > 0 ? (
        <>
          {rating}{' '}
          <Rating
            id="rating-stars"
            value={starRating}
            precision={0.5}
            readOnly
            size="small"
          />
        </>
      ) : (
        <span className="no-feedback">No Feedback</span>
      )}
    </Grid>
  );
}
